module.exports = __webpack_public_path__ + "media/logos/billtrust-logo-265de9ff.png";